import { z } from '@hono/zod-openapi'
import { LANGUAGE_CODES } from '@shared/config/i18n/locales'

export const languageCodeSchema = z.enum(LANGUAGE_CODES)

export const updateUserLocaleRequestSchema = z
  .object({
    timezoneCode: z.string().min(1).optional(),
    languageCode: languageCodeSchema.optional(),
  })
  .refine(({ timezoneCode, languageCode }) => timezoneCode !== undefined || languageCode !== undefined, {
    message: 'USER_LOCALE_FIELD_REQUIRED',
  })

export const userLocaleResponseSchema = z.object({
  timezoneCode: z.string().nullable(),
  languageCode: languageCodeSchema,
})

export type UpdateUserLocaleRequest = z.infer<typeof updateUserLocaleRequestSchema>
export type UserLocaleResponse = z.infer<typeof userLocaleResponseSchema>
